export default __webpack_public_path__ + "static/media/ic-external-link.4696adc1.svg";